import { MoneySourceContainer } from '../../../MoneySource';
import { WithoutServicesScreenContainer } from '../WithoutServicesScreen';
import { PromotionSectionContainer } from '../PromotionSection';
import * as React from 'react';
import { IPromotionContentProps } from '../../PromotionContainer';
import { SubAgentPromotionLimitExceedCard } from '../SubAgentPromotionLimitExceedCard';

export const PromotionContent = ({
  showNoServicesScreen,
  showMoneySourceWidget,
  isSubagentLimitExceed,
}: IPromotionContentProps) => {
  return (
    <>
      {showMoneySourceWidget && <MoneySourceContainer />}
      {isSubagentLimitExceed ? (
        <SubAgentPromotionLimitExceedCard />
      ) : showNoServicesScreen ? (
        <WithoutServicesScreenContainer />
      ) : (
        <PromotionSectionContainer />
      )}
    </>
  );
};
